import { render, staticRenderFns } from "./AneelComprovante.vue?vue&type=template&id=476efb30&"
import script from "./AneelComprovante.vue?vue&type=script&lang=js&"
export * from "./AneelComprovante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports